import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconAI = createSVG({
    children: (jsx("path", { d: "M17.664 8.792a1.28 1.28 0 0 0 1.28-1.264c0-.688-.576-1.28-1.28-1.28-.688 0-1.264.592-1.264 1.28s.576 1.264 1.264 1.264m-4.415 8.96h2.4l-3.936-11.2H8.977l-3.92 11.2H7.44l.672-2.016h4.464zm-4.432-4.08 1.536-4.576 1.536 4.576zm7.823 4.08h2.064v-8H16.64z" })),
});

export { IconAI };
